import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ReframeSection } from './components/ReframeSection';
import { HonestySection } from './components/HonestySection';
import { StorySection } from './components/StorySection';
import { OfferSection } from './components/OfferSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { StickyMobileCta } from './components/StickyMobileCta';
import { MicroImpactBlock } from './components/MicroImpactBlock';
import { BeginnerSection } from './components/BeginnerSection';
export function App() {
  useEffect(() => {
    document.title = "La Fórmula";
  }, []);
  return <main className="w-full min-h-screen bg-black font-sans selection:bg-white selection:text-black pb-28 md:pb-0" data-id="element-0">
        {/* 1. HERO */}
        <HeroSection data-id="element-1" />

        {/* 3. CORE IDEA */}
        <ReframeSection data-id="element-2" />

        {/* 4. AHA BLOCK */}
        <MicroImpactBlock text="" theme="light" data-id="element-3" />

        {/* 5. HONESTY */}
        <HonestySection data-id="element-4" />

        {/* 6. MICRO STORY */}
        <StorySection data-id="element-5" />

        {/* 7. BEGINNER BLOCK */}
        <BeginnerSection data-id="element-6" />

        {/* 8. OFFER */}
        <OfferSection data-id="element-7" />

        {/* 9. FAQ */}
        <ObjectionsSection data-id="element-8" />

        {/* 10. FINAL CTA */}
        <FinalCtaSection data-id="element-9" />

        <StickyMobileCta data-id="element-10" />
      </main>;
}